import styled from 'styled-components'
import { Modal } from '../../../components'

export const BootstrapModal = styled(Modal)`
  display: flex !important;
`

export const Wrapper = styled.div`
  width: 100%;
  display: flex; 
  justify-content: space-evenly;
`
